import { z } from 'zod';

import { AreaOfStudyCategory } from '../../enums/generated/area-of-study-category';

export const AdminModalAreasOfStudyFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(3, { message: 'Name must contain at least 3 characters' })
    .max(50, { message: 'Name must be no more than 50 characters' }),
  category: z.nativeEnum(AreaOfStudyCategory),
});

export type AdminModalAreasOfStudyFormValues = z.infer<
  typeof AdminModalAreasOfStudyFormSchema
>;
